import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { LoginModule, SharedModule, UiModule } from './';
import { appRouting } from '../routing';
import { AppComponent } from '../../components';
import * as firebase from 'firebase/app';
import 'firebase/performance';
import 'firebase/analytics';
import { getPerformance } from 'firebase/performance';


const firebaseInitialisationOptions = {
	apiKey: 'AIzaSyDMAJy18HkkMo_MeOV269VepZU6UCwB5-o',
  appId: '1:463395559657:web:9c8b55f24eba9a635ef878',
	authDomain: 'live-bwrm-processor-prism.firebaseapp.com',
	databaseURL: 'https://live-bwrm-processor-prism.firebaseio.com',
	projectId: 'live-bwrm-processor-prism',
	storageBucket: 'live-bwrm-processor-prism',
};

export const memberApp = firebase.initializeApp({
  apiKey: 'AIzaSyDA23Wi5MaROVIMXgthn0o4M2sTKQTirfY',
  appId: '1:1001308185462:web:5d2ed599daec50ed21d057',
  authDomain: 'live-bwrm-prism.firebaseapp.com',
  databaseURL: 'https://live-bwrm-prism.firebaseio.com',
  projectId: 'live-bwrm-prism',
  storageBucket: 'live-bwrm-prism',
  messagingSenderId: '1001308185462'
}, 'live-bwrm-prism');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    appRouting,
    LoginModule,
    UiModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule.forRoot()
  ],
  exports: [
    LoginModule,
    UiModule,
    BrowserModule,
    BrowserAnimationsModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    const processorApp = firebase.initializeApp(firebaseInitialisationOptions);
    const perf = getPerformance(processorApp);
  }
}
